import PocketBase from 'pocketbase'

export const pb = new PocketBase('https://pb.iswarajatim.com')
pb.autoCancellation(false)

export default pb
